const accountsReceivableBackdrop     = require('./accountsReceivable-backdrop')
const accountsReceivableConfirmation = require('./accountsReceivable-confirmation')
const accountsReceivableDialog       = require('./accountsReceivable-dialog')
const accountsReceivableDt           = require('./accountsReceivable-dt')
const accountsReceivableFullcont     = require('./accountsReceivable-fullcont')
const accountsReceivableMenu         = require('./accountsReceivable-menu')
const accountsReceivablePage         = require('./accountsReceivable-page')
const accountsReceivableSnack        = require('./accountsReceivable-snack')
const accountsReceivableFetch        = require('./accountsReceivable-fetch')
const saleFullcont2                  = require('./sale2/sale-fullcont')
const mtsaleFullcont2                  = require('./sale2/sale-fullcont-multitable')

export function start(detail){  //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      backdrop:        { start: (detail) =>{  accountsReceivableBackdrop.start(detail)         }},
      confirmation:    { start: (detail) =>{  accountsReceivableConfirmation.start(detail)     }},
      dialog:          { start: (detail) =>{  accountsReceivableDialog.start(detail)           }},
      dt:              { start: (detail) =>{  accountsReceivableDt. start(detail)              }},
      fullcont:        { start: (detail) =>{  accountsReceivableFullcont. start(detail)        }},
      menu:            { start: (detail) =>{  accountsReceivableMenu.start(detail)             }},
      page:            { start: (detail) =>{  accountsReceivablePage.start(detail)             }},
      snack:           { start: (detail) =>{  accountsReceivableSnack.start(detail)            }},
      fetch:           { start: (detail) =>{  accountsReceivableFetch.start(detail)            }},
      saleFullcont2:   { start: (detail) =>{  saleFullcont2.start(detail)                      }},
      mtsaleFullcont2: { start: (detail) =>{  mtsaleFullcont2.start(detail)                    }},
}